import { StyledTabs_default, StyledTab_default } from './chunk-NOJ74DUO.js';
import { SingleSelect_default, ApplyCancel_default } from './chunk-6UBOFWLJ.js';
import { ErrorBoundary_default } from './chunk-NJFJDBQA.js';
import { ThemeProvider, defaultTheme_default } from './chunk-J2FXRRBJ.js';
import { __spreadValues, __async } from './chunk-2FEJBM4N.js';
import { Box, Typography, CircularProgress, TextField, useTheme, useMediaQuery, Button, Popover, Slider, Fade, List, ListItemButton } from '@mui/material';
import React15, { useState, useEffect, useMemo } from 'react';
import moment3 from 'moment';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Calendar, DateObject } from 'react-multi-date-picker';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';
import { get, set } from 'lodash';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { get as get$1 } from 'react-hook-form';

var CurrencyInput = ({
  label,
  value,
  helperText,
  onChange,
  limit,
  limitLoading,
  setWithinLimit
}) => {
  const [error, setError] = useState(null);
  const [stringValue, setStringValue] = useState("");
  const handleInputChange = (e) => {
    const inputValue = e.target.value.replace(/,/g, "");
    const numericRegex = /^\d*\.?\d*$/;
    if (!numericRegex.test(inputValue)) {
      return;
    }
    setStringValue(e.target.value);
    if (inputValue === "") {
      onChange(0);
    } else {
      const newValue = parseFloat(inputValue);
      if (!isNaN(newValue)) {
        onChange(newValue);
      }
    }
  };
  useEffect(() => {
    if (value === 0) {
      setStringValue("");
    } else {
      setStringValue(value.toLocaleString("en-US"));
    }
  }, [value]);
  useEffect(() => {
    if (((limit == null ? void 0 : limit.min) || (limit == null ? void 0 : limit.max)) && value !== null && value !== void 0) {
      if ((limit == null ? void 0 : limit.min) && value < (limit == null ? void 0 : limit.min)) {
        setError(`Minimum value is $${limit == null ? void 0 : limit.min}`);
        setWithinLimit == null ? void 0 : setWithinLimit(false);
      } else if ((limit == null ? void 0 : limit.max) && value > (limit == null ? void 0 : limit.max)) {
        setError(`Maximum value is $${limit == null ? void 0 : limit.max}`);
        setWithinLimit == null ? void 0 : setWithinLimit(false);
      } else {
        setError(null);
        setWithinLimit == null ? void 0 : setWithinLimit(true);
      }
    } else {
      setError(null);
      setWithinLimit == null ? void 0 : setWithinLimit(true);
    }
  }, [value, limit == null ? void 0 : limit.min, limit == null ? void 0 : limit.max]);
  return /* @__PURE__ */ React15.createElement(ErrorBoundary_default, { componentName: "CurrencyInput" }, /* @__PURE__ */ React15.createElement(ThemeProvider, null, /* @__PURE__ */ React15.createElement(Box, { width: "100%" }, /* @__PURE__ */ React15.createElement(Box, { display: "flex", alignItems: "center", gap: 1.5 }, /* @__PURE__ */ React15.createElement(Typography, { fontSize: 14, color: "#000", fontWeight: 600 }, label), limitLoading && /* @__PURE__ */ React15.createElement(CircularProgress, { size: 20 })), /* @__PURE__ */ React15.createElement(
    Box,
    {
      position: "relative",
      display: "flex",
      alignItems: "flex-end",
      mt: 2,
      height: "42px"
    },
    /* @__PURE__ */ React15.createElement(
      TextField,
      {
        disabled: limitLoading,
        value: stringValue,
        inputProps: {
          min: 0,
          step: 0.1
        },
        type: "text",
        variant: "standard",
        placeholder: "e.g. $1,500",
        onChange: handleInputChange,
        sx: {
          width: "100%",
          "& .MuiInputBase-input": {
            fontSize: "24px",
            color: "#000",
            p: "3px 0 3px 34px"
          }
        }
      }
    ),
    /* @__PURE__ */ React15.createElement(Box, { position: "absolute", left: "8px", bottom: "5px" }, /* @__PURE__ */ React15.createElement(
      Typography,
      {
        fontSize: 24,
        color: "#000",
        fontWeight: 600,
        lineHeight: "initial"
      },
      "$"
    ))
  ), /* @__PURE__ */ React15.createElement(Box, { height: "15px", mt: 2 }, error && /* @__PURE__ */ React15.createElement(Typography, { fontSize: 14, color: "#E52E2E", lineHeight: "initial" }, error))), helperText && /* @__PURE__ */ React15.createElement(Box, null, /* @__PURE__ */ React15.createElement(Box, { height: "21px", width: "100%" }), /* @__PURE__ */ React15.createElement(Box, { mt: 2, height: "42px", display: "flex", alignItems: "center" }, /* @__PURE__ */ React15.createElement(Typography, { fontSize: 16, color: "#000", lineHeight: "initial" }, helperText)))));
};
var CurrencyInput_default = CurrencyInput;
var CalendarRangeComp = (props) => {
  const {
    value,
    onChange: propsOnChange,
    minDate,
    maxDate,
    weekStartDay,
    onlyMonthPicker,
    rootSx,
    selectableRanges
  } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [hoveredRange, setHoveredRange] = React15.useState(null);
  const mapDays = React15.useCallback(
    ({ date }) => {
      if (!selectableRanges || selectableRanges.length === 0) {
        return;
      }
      const momentDate = moment3(date.format("YYYY-MM-DD"));
      const allMatchingRanges = selectableRanges.filter(
        (range) => momentDate.isBetween(range.start, range.end, "day", "[]")
      );
      if (allMatchingRanges.length === 0) {
        return {
          disabled: true,
          style: {
            color: "#ccc",
            pointerEvents: "none"
          }
        };
      }
      let rangeToHighlight = allMatchingRanges[0];
      if (allMatchingRanges.length > 1 && hoveredRange) {
        const hoveredRangeMatch = allMatchingRanges.find(
          (range) => range.start.isSame(hoveredRange.start) && range.end.isSame(hoveredRange.end)
        );
        if (hoveredRangeMatch) {
          rangeToHighlight = hoveredRangeMatch;
        } else {
          rangeToHighlight = allMatchingRanges.reduce(
            (latest, current) => current.start.isAfter(latest.start) ? current : latest
          );
        }
      }
      const isWithinDateBounds = (!minDate || momentDate.isSameOrAfter(
        moment3(minDate.format("YYYY-MM-DD")),
        "day"
      )) && (!maxDate || momentDate.isSameOrBefore(
        moment3(maxDate.format("YYYY-MM-DD")),
        "day"
      ));
      const isRangeHovered = hoveredRange && rangeToHighlight.start.isSame(hoveredRange.start) && rangeToHighlight.end.isSame(hoveredRange.end) && isWithinDateBounds;
      return {
        onMouseEnter: () => setHoveredRange(rangeToHighlight),
        onMouseLeave: () => setHoveredRange(null),
        className: isRangeHovered ? "range-hover" : void 0
      };
    },
    [selectableRanges, hoveredRange, minDate, maxDate]
  );
  return /* @__PURE__ */ React15.createElement(
    Box,
    {
      sx: __spreadValues({
        "& .rmdp-calendar, & .rmdp-range-picker, & .rmdp-day-picker": {
          p: 0
        },
        "& .rmdp-shadow": {
          boxShadow: "none",
          fontFamily: theme.typography.fontFamily
        },
        "& .rmdp-header > div": {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingX: "8px"
        },
        "& .rmdp-header-values": {
          margin: 0,
          flex: 1,
          textAlign: "left",
          fontSize: "14px",
          "& span:first-child": {
            fontWeight: 600
          },
          "& span:last-child": {
            fontWeight: 600,
            color: "rgba(0, 0, 0, 0.35)"
          }
        },
        "& .rmdp-arrow-container": {
          flex: 0
        },
        "& .rmdp-week-day": {
          fontSize: "12px",
          fontWeight: 600,
          color: "#000",
          width: isMobile ? 36 : 46,
          textAlign: "center",
          height: "32px"
        },
        "& .rmdp-day": {
          borderRadius: "2px !important",
          border: "1px solid #fff",
          width: isMobile ? 36 : 46,
          height: "32px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "&:hover": {
            bgcolor: "rgba(25, 110, 130, 0.24)"
          },
          "& span": {
            position: "relative",
            top: "0px",
            bottom: "0px",
            left: "0px",
            right: "0px",
            fontSize: "12px",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "2px !important",
            backgroundColor: "transparent !important",
            "&:hover": {
              backgroundColor: "transparent !important",
              color: "inherit !important"
            }
          }
        },
        "& .rmdp-range-hover": {
          backgroundColor: "rgba(25, 110, 130, 0.12)",
          color: "inherit"
        },
        "& .rmdp-day:has(.range-hover)": {
          backgroundColor: "rgba(25, 110, 130, 0.24)",
          color: "inherit",
          borderRadius: "2px"
        },
        "& .rmdp-range": {
          color: "inherit",
          fontWeight: 600,
          border: "1px solid #fff",
          bgcolor: "rgba(25, 110, 130, 0.12)",
          boxShadow: "none"
        },
        "& .start > span, & .end > span, & .rmdp-range-hover.start:not(.force), .rmdp-range.start:not(.force), & .rmdp-range-hover.end:not(.force), .rmdp-range.end:not(.force)": {
          borderRadius: "2px"
        },
        "& .start, & .end": {
          border: "1px solid #196E82"
        },
        "& .rmdp-disabled": {
          color: "rgba(0, 0, 0, 0.25)",
          pointerEvents: "none"
        }
      }, rootSx)
    },
    /* @__PURE__ */ React15.createElement(
      Calendar,
      {
        onlyMonthPicker: !!onlyMonthPicker,
        value,
        onChange: propsOnChange,
        minDate,
        maxDate,
        range: true,
        rangeHover: true,
        mapDays,
        headerOrder: ["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"],
        weekDays: weekDayLabels,
        weekStartDayIndex: weekStartDay ? weekDayLabels.indexOf(weekStartDay) : void 0,
        highlightToday: false,
        showOtherDays: true,
        disableMonthPicker: !onlyMonthPicker,
        disableYearPicker: true,
        renderButton: (direction, handleClick) => /* @__PURE__ */ React15.createElement(
          Button,
          {
            variant: "text",
            onClick: handleClick,
            sx: {
              backgroundColor: "#F3F3F3",
              minWidth: 0,
              padding: "2px 4px",
              borderRadius: "2px",
              color: "#000",
              marginLeft: direction === "right" ? "4px" : 0,
              "&:hover": {
                backgroundColor: "#E0E0E0"
              }
            }
          },
          direction === "right" ? /* @__PURE__ */ React15.createElement(ChevronRight, { fontSize: "small" }) : /* @__PURE__ */ React15.createElement(ChevronLeft, { fontSize: "small" })
        )
      }
    )
  );
};
var CalendarRangeComp_default = CalendarRangeComp;
function dateInRange(obj) {
  if (!obj.startDate && obj.endDate) {
    return obj.date.isBefore(obj.endDate);
  } else if (obj.startDate && !obj.endDate) {
    return obj.date.isAfter(obj.startDate);
  } else if (obj.startDate && obj.endDate) {
    return obj.date.isBetween(obj.startDate, obj.endDate);
  }
  return true;
}
function getDateInRange(obj) {
  if (dateInRange(obj)) {
    return obj.date;
  }
  if (obj.startDate && !obj.endDate && obj.date.isBefore(obj.startDate)) {
    return obj.startDate;
  } else if (obj.endDate && !obj.startDate && obj.date.isAfter(obj.endDate)) {
    return obj.endDate;
  } else if (obj.startDate && obj.endDate) {
    if (obj.date.isBefore(obj.startDate)) {
      return obj.startDate;
    } else if (obj.date.isAfter(obj.endDate)) {
      return obj.endDate;
    }
  }
  return obj.date;
}
function getLastMonthRange(monthCount, minDate, maxDate) {
  const minMonth = minDate ? minDate.clone().startOf("months") : null;
  const maxMonth = maxDate ? maxDate.clone().endOf("months") : null;
  const tempEndDate = moment3().endOf("months");
  const endDate = (dateInRange({
    date: tempEndDate,
    startDate: minMonth,
    endDate: maxMonth
  }) ? tempEndDate : maxMonth).clone();
  const tempStartDate = endDate.clone().subtract(monthCount - 1, "months").startOf("months");
  const startDate = (dateInRange({
    date: tempStartDate,
    startDate: minMonth,
    endDate: maxMonth
  }) ? tempStartDate : minMonth).clone();
  return {
    start: startDate,
    end: endDate
  };
}

// src/components/Datetime/components/QuickSelect.tsx
var QuickSelect = (props) => {
  const {
    handleApplyDateRange,
    minDate,
    maxDate,
    showLastWeekShortcut,
    showMonthSelect,
    showQuarterSelect,
    showClearButton
  } = props;
  const [lastWeek, lastTwelveMonths, lastFourQuarters] = React15.useMemo(() => {
    const week = {
      start: getDateInRange({
        date: maxDate ? moment3(maxDate).subtract(1, "weeks").startOf("isoWeek") : moment3().subtract(1, "weeks").startOf("isoWeek"),
        startDate: minDate,
        endDate: maxDate
      }),
      end: getDateInRange({
        date: maxDate ? moment3(maxDate).subtract(1, "weeks").endOf("isoWeek") : moment3().subtract(1, "weeks").endOf("isoWeek"),
        startDate: minDate,
        endDate: maxDate
      })
    };
    const months = [];
    for (let i = 0; i < 12; i++) {
      const startDate = moment3(maxDate).subtract(i, "months").startOf("months");
      const endDate = moment3(maxDate).subtract(i, "months").endOf("months");
      const startDateInRange = dateInRange({
        date: startDate,
        startDate: minDate,
        endDate: maxDate
      });
      const endDateInRange = dateInRange({
        date: endDate,
        startDate: minDate,
        endDate: maxDate
      });
      if (startDateInRange || endDateInRange) {
        months.push({
          start: startDate,
          end: endDate
        });
      }
    }
    const quarters = [];
    for (let i = 1; i <= 4; i++) {
      quarters.push({
        start: moment3().subtract(i, "quarters").startOf("quarters"),
        end: moment3().subtract(i, "quarters").endOf("quarters")
      });
    }
    return [week, months, quarters];
  }, [moment3().format("DD-MM-YYYY"), minDate, maxDate]);
  return /* @__PURE__ */ React15.createElement(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "8px"
      }
    },
    showLastWeekShortcut && /* @__PURE__ */ React15.createElement(
      Button,
      {
        variant: "text",
        onClick: () => {
          handleApplyDateRange(lastWeek);
        },
        sx: {
          padding: "8px 12px",
          color: "#000",
          fontSize: "12px",
          backgroundColor: "#F3F3F3",
          "&:hover": { backgroundColor: "#E4E4E4" }
        }
      },
      /* @__PURE__ */ React15.createElement(Typography, { fontSize: "12px", color: "black" }, "Last week", " ", /* @__PURE__ */ React15.createElement("b", { style: { marginLeft: 2 } }, "(", lastWeek.start.format("DD MMM"), " -", " ", lastWeek.end.format("DD MMM"), ")"))
    ),
    showMonthSelect && lastTwelveMonths.length && /* @__PURE__ */ React15.createElement(
      SingleSelect_default,
      {
        options: lastTwelveMonths.map((month) => {
          return {
            value: month.start.format("MMMM 'YY"),
            label: month.start.format("MMMM 'YY")
          };
        }),
        onChange: (value) => {
          const monthStart = getDateInRange({
            date: moment3(value, "MMMM 'YY").startOf("months"),
            startDate: minDate,
            endDate: maxDate
          });
          const monthEnd = getDateInRange({
            date: moment3(value, "MMMM 'YY").endOf("months"),
            startDate: minDate,
            endDate: maxDate
          });
          handleApplyDateRange({
            start: monthStart,
            end: monthEnd
          });
        },
        value: null,
        renderValue: (value) => "Select Month",
        disableSort: true,
        disableSearch: true
      }
    ),
    showQuarterSelect && /* @__PURE__ */ React15.createElement(
      SingleSelect_default,
      {
        options: lastFourQuarters.map((quarter, index) => {
          return {
            value: `(${quarter.start.format(
              "MMM 'YY"
            )} - ${quarter.end.format("MMM 'YY")})`,
            label: `Q${quarter.start.quarter()} of ${quarter.start.format(
              "YYYY"
            )} (${quarter.start.format("MMM")} - ${quarter.end.format(
              "MMM"
            )})`
          };
        }),
        onChange: (value) => {
          const quarterStart = moment3(value.split(" - ")[0], "MMM 'YY");
          const quarterEnd = moment3(value.split(" - ")[1], "MMM 'YY").endOf(
            "months"
          );
          handleApplyDateRange({
            start: quarterStart,
            end: quarterEnd
          });
        },
        value: null,
        renderValue: (value) => "Select Quarter",
        disableSort: true,
        disableSearch: true
      }
    ),
    showClearButton && /* @__PURE__ */ React15.createElement(
      Button,
      {
        variant: "text",
        onClick: () => {
          handleApplyDateRange({ start: null, end: null });
        },
        sx: {
          padding: "8px 12px",
          color: "#000",
          fontSize: "12px",
          backgroundColor: "#F3F3F3",
          "&:hover": { backgroundColor: "#E4E4E4" },
          "& .MuiButton-startIcon": { marginLeft: 0 },
          "& .MuiSvgIcon-root": { fontSize: "12px" }
        },
        startIcon: /* @__PURE__ */ React15.createElement(
          EventBusyIcon,
          {
            sx: { width: "12px", height: "12px", color: "black" }
          }
        )
      },
      /* @__PURE__ */ React15.createElement(Typography, { fontSize: "12px", color: "black" }, "Clear Date Range")
    )
  );
};
var QuickSelect_default = QuickSelect;

// src/components/Datetime/DateRangePicker/DateRangePicker.tsx
var weekDayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var findRangeForDate = (date, ranges) => {
  return ranges.find(
    (range) => date.isBetween(range.start, range.end, "day", "[]")
  ) || null;
};
var DateRangePicker = (props) => {
  var _a, _b, _c, _d;
  const {
    value: propsValue,
    onChange,
    disabled,
    minDate,
    maxDate,
    renderValue,
    label,
    showLastWeekShortcut,
    showClearButton,
    showMonthSelect,
    showQuarterSelect,
    weekStartDay,
    rootButtonSx,
    disableScrollLock,
    selectableRanges,
    extraComponent
  } = props;
  const [anchorEl, setAnchorEl] = React15.useState(null);
  const [value, setValue] = React15.useState({
    start: (propsValue == null ? void 0 : propsValue.start) || null,
    end: (propsValue == null ? void 0 : propsValue.end) || null
  });
  const isMobile = useMediaQuery(defaultTheme_default.breakpoints.down("sm"));
  React15.useEffect(() => {
    setValue({
      start: (propsValue == null ? void 0 : propsValue.start) || null,
      end: (propsValue == null ? void 0 : propsValue.end) || null
    });
  }, [propsValue]);
  const showApplyBtn = React15.useMemo(() => {
    const propsStart = get(propsValue, "start", null);
    const localStart = get(value, "start", null);
    const propsEnd = get(propsValue, "end", null);
    const localEnd = get(value, "end", null);
    if (!localStart || !localEnd) return false;
    if (propsStart && propsEnd && localStart && localEnd && propsStart.isSame(localStart) && propsEnd.isSame(localEnd))
      return false;
    return true;
  }, [value, propsValue]);
  const handleDateRangeChange = (newDateRange) => {
    if (selectableRanges && selectableRanges.length > 0 && newDateRange.length >= 1) {
      const clickedDate = moment3(
        newDateRange[newDateRange.length - 1].format("YYYY-MM-DD")
      );
      const matchingRange = findRangeForDate(clickedDate, selectableRanges);
      if (matchingRange) {
        setValue({
          start: matchingRange.start,
          end: matchingRange.end
        });
      }
    } else if (newDateRange.length === 2) {
      setValue({
        start: moment3(newDateRange[0].format("YYYY-MM-DD")),
        end: moment3(newDateRange[1].format("YYYY-MM-DD"))
      });
    }
  };
  const handleApplyDateRange = (newDateRange) => {
    onChange(newDateRange ? __spreadValues({}, newDateRange) : __spreadValues({}, value));
    setAnchorEl(null);
  };
  const handleCancel = () => {
    setAnchorEl(null);
    setValue(__spreadValues({}, propsValue));
  };
  return /* @__PURE__ */ React15.createElement(ErrorBoundary_default, { componentName: "DateRangePicker" }, /* @__PURE__ */ React15.createElement(ThemeProvider, null, /* @__PURE__ */ React15.createElement(
    Popover,
    {
      id: "date-range-popover",
      anchorEl,
      open: Boolean(anchorEl),
      onClose: handleCancel,
      marginThreshold: 20,
      disableScrollLock,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React15.createElement(
      Box,
      {
        sx: {
          padding: isMobile ? "8px" : "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          boxSizing: "border-box",
          maxWidth: isMobile ? 282 : 368
        }
      },
      extraComponent && /* @__PURE__ */ React15.createElement(Box, { sx: { marginBottom: "8px" } }, extraComponent),
      /* @__PURE__ */ React15.createElement(
        CalendarRangeComp_default,
        {
          value: [
            new DateObject((_a = value.start) == null ? void 0 : _a.format("YYYY-MM-DD")),
            new DateObject((_b = value.end) == null ? void 0 : _b.format("YYYY-MM-DD"))
          ],
          onChange: handleDateRangeChange,
          minDate: minDate && new DateObject(minDate.format("YYYY-MM-DD")),
          maxDate: maxDate && new DateObject(maxDate.format("YYYY-MM-DD")),
          weekStartDay: weekStartDay || "Sun",
          selectableRanges
        }
      ),
      /* @__PURE__ */ React15.createElement(
        QuickSelect_default,
        {
          handleApplyDateRange,
          minDate,
          maxDate,
          showLastWeekShortcut,
          showMonthSelect,
          showQuarterSelect,
          showClearButton
        }
      )
    ),
    showApplyBtn && /* @__PURE__ */ React15.createElement(
      ApplyCancel_default,
      {
        handleApplyClick: handleApplyDateRange,
        handleCancelClick: handleCancel,
        isChanged: showApplyBtn,
        changedLabel: `${(_c = value.start) == null ? void 0 : _c.format(
          "DD MMM"
        )} - ${(_d = value.end) == null ? void 0 : _d.format("DD MMM")}`
      }
    )
  ), /* @__PURE__ */ React15.createElement(
    Button,
    {
      variant: "text",
      size: "small",
      onClick: (e) => {
        setAnchorEl(e.currentTarget);
      },
      startIcon: /* @__PURE__ */ React15.createElement(
        DateRangeIcon,
        {
          sx: { width: "12px", height: "12px", color: "black" }
        }
      ),
      endIcon: /* @__PURE__ */ React15.createElement(ExpandMoreIcon, { sx: { width: "16px", height: "16px" } }),
      sx: __spreadValues({
        padding: "7px 8px",
        color: "#000",
        backgroundColor: "#F3F3F3",
        "& .MuiButton-startIcon": { marginLeft: 0 },
        "& .MuiButton-endIcon": { marginRight: 0 },
        "&:hover": { backgroundColor: "#E4E4E4" },
        "&.Mui-disabled": { bgcolor: "#F3F3F3" }
      }, rootButtonSx),
      disabled
    },
    /* @__PURE__ */ React15.createElement(Typography, { fontSize: "12px", color: "black" }, renderValue ? renderValue(value) : propsValue && propsValue.start && propsValue.end ? `${propsValue.start.format(
      "MM-DD-YYYY"
    )} to ${propsValue.end.format("MM-DD-YYYY")}` : `Select ${label ? label : "Date Range"}`)
  )));
};
var DateRangePicker_default = DateRangePicker;

// src/components/Datetime/components/CalendarComp.tsx
var CalendarRangeComp2 = (props) => {
  const {
    value,
    onChange: propsOnChange,
    minDate,
    maxDate,
    weekStartDay,
    highlightToday = true,
    rootSx
  } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return /* @__PURE__ */ React15.createElement(
    Box,
    {
      sx: __spreadValues({
        "& .rmdp-calendar, & .rmdp-day-picker": {
          p: 0
        },
        "& .rmdp-shadow": {
          boxShadow: "none",
          fontFamily: theme.typography.fontFamily
        },
        "& .rmdp-header > div": {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingX: "8px"
        },
        "& .rmdp-header-values": {
          margin: 0,
          flex: 1,
          textAlign: "left",
          fontSize: "14px",
          "& span:first-child": {
            fontWeight: 600
          },
          "& span:last-child": {
            fontWeight: 600,
            color: "rgba(0, 0, 0, 0.35)"
          }
        },
        "& .rmdp-arrow-container": {
          flex: 0
        },
        "& .rmdp-week-day": {
          fontSize: "12px",
          fontWeight: 600,
          color: "#000",
          width: isMobile ? 36 : 46,
          textAlign: "center",
          height: "32px"
        },
        "& .rmdp-day": {
          border: "1px solid #fff",
          width: isMobile ? 36 : 46,
          height: "32px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "&:hover": {
            bgcolor: "rgba(25, 110, 130, 0.24)"
          },
          "& span": {
            position: "relative",
            top: "0px",
            bottom: "0px",
            left: "0px",
            right: "0px",
            fontSize: "12px",
            "&:hover": {
              backgroundColor: "transparent !important",
              color: "inherit !important"
            }
          }
        },
        "& .rmdp-day:not(.rmdp-range):focus": {
          borderRadius: "2px"
        },
        "& .rmdp-selected": {
          bgcolor: "rgba(25, 110, 130, 0.12)",
          border: "1px solid #196E82",
          fontWeight: 600,
          color: "inherit",
          boxShadow: "none",
          "& span, & span:not(.highlight)": {
            color: "inherit",
            fontWeight: "inherit",
            borderRadius: "inherit",
            boxShadow: "inherit",
            background: "none"
          }
        },
        "& .rmdp-today": {
          color: "#196E82",
          fontWeight: 500,
          "&:after": {
            content: '"Today"',
            position: "absolute",
            top: "-20px",
            right: 0,
            left: 0,
            display: "none",
            textAlign: "center",
            backgroundColor: "#000c",
            color: "#fff",
            borderRadius: "2px",
            padding: "3px",
            fontSize: "11px",
            fontWeight: 400
          },
          "&:hover:after": {
            display: "block"
          },
          "& span": {
            color: "inherit",
            background: "none"
          }
        },
        "& .rmdp-disabled": {
          color: "rgba(0, 0, 0, 0.25)",
          pointerEvents: "none"
        }
      }, rootSx)
    },
    /* @__PURE__ */ React15.createElement(
      Calendar,
      {
        value,
        onChange: propsOnChange,
        minDate,
        maxDate,
        headerOrder: ["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"],
        weekDays: weekDayLabels,
        weekStartDayIndex: weekStartDay ? weekDayLabels.indexOf(weekStartDay) : void 0,
        highlightToday,
        showOtherDays: true,
        disableMonthPicker: true,
        disableYearPicker: true,
        renderButton: (direction, handleClick) => /* @__PURE__ */ React15.createElement(
          Button,
          {
            variant: "text",
            onClick: handleClick,
            sx: {
              backgroundColor: "#F3F3F3",
              minWidth: 0,
              padding: "2px 4px",
              borderRadius: "2px",
              color: "#000",
              marginLeft: direction === "right" ? "4px" : 0,
              "&:hover": {
                backgroundColor: "#E0E0E0"
              }
            }
          },
          direction === "right" ? /* @__PURE__ */ React15.createElement(ChevronRight, { fontSize: "small" }) : /* @__PURE__ */ React15.createElement(ChevronLeft, { fontSize: "small" })
        )
      }
    )
  );
};
var CalendarComp_default = CalendarRangeComp2;

// src/components/Datetime/DatePicker/DatePicker.tsx
var DatePicker = (props) => {
  const {
    value,
    onChange,
    disabled,
    minDate,
    maxDate,
    renderValue,
    label,
    weekStartDay,
    highlightToday = true,
    rootButtonSx,
    disableScrollLock
  } = props;
  const [anchorEl, setAnchorEl] = React15.useState(null);
  const isMobile = useMediaQuery(defaultTheme_default.breakpoints.down("sm"));
  const currentValue = React15.useMemo(() => {
    return value ? new DateObject(value.format("YYYY-MM-DD")) : null;
  }, [value]);
  const handleDateChange = (date) => {
    const newValue = moment3(date.format("YYYY-MM-DD"));
    onChange(newValue);
    handleCancel();
  };
  const handleCancel = () => {
    setAnchorEl(null);
  };
  return /* @__PURE__ */ React15.createElement(ErrorBoundary_default, { componentName: "DatePicker" }, /* @__PURE__ */ React15.createElement(ThemeProvider, null, /* @__PURE__ */ React15.createElement(
    Popover,
    {
      id: "date-range-popover",
      anchorEl,
      open: Boolean(anchorEl),
      onClose: handleCancel,
      marginThreshold: 20,
      disableScrollLock,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React15.createElement(
      Box,
      {
        sx: {
          padding: isMobile ? "8px" : "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          boxSizing: "border-box",
          maxWidth: isMobile ? 282 : 368
        }
      },
      /* @__PURE__ */ React15.createElement(
        CalendarComp_default,
        {
          value: currentValue,
          onChange: handleDateChange,
          minDate: minDate && new DateObject(minDate.format("YYYY-MM-DD")),
          maxDate: maxDate && new DateObject(maxDate.format("YYYY-MM-DD")),
          weekStartDay: weekStartDay || "Sun",
          highlightToday
        }
      )
    )
  ), /* @__PURE__ */ React15.createElement(
    Button,
    {
      variant: "text",
      size: "small",
      onClick: (e) => {
        setAnchorEl(e.currentTarget);
      },
      startIcon: /* @__PURE__ */ React15.createElement(
        DateRangeIcon,
        {
          sx: { width: "12px", height: "12px", color: "black" }
        }
      ),
      endIcon: /* @__PURE__ */ React15.createElement(ExpandMoreIcon, { sx: { width: "16px", height: "16px" } }),
      sx: __spreadValues({
        padding: "7px 8px",
        color: "#000",
        backgroundColor: "#F3F3F3",
        "& .MuiButton-startIcon": { marginLeft: 0 },
        "& .MuiButton-endIcon": { marginRight: 0 },
        "&:hover": { backgroundColor: "#E4E4E4" },
        "&.Mui-disabled": { bgcolor: "#F3F3F3" }
      }, rootButtonSx),
      disabled
    },
    /* @__PURE__ */ React15.createElement(Typography, { fontSize: "12px", color: "black" }, renderValue ? renderValue(value) : value ? `${value.format("MM-DD-YYYY")}` : `Select ${label ? label : "Date"}`)
  )));
};
var DatePicker_default = DatePicker;

// src/components/FormFlow/DatePickerInput.tsx
var DatePickerInput = ({
  label,
  value,
  helperText,
  onChange,
  minDate,
  maxDate,
  limit,
  limitLoading,
  setWithinLimit
}) => {
  const [error, setError] = useState(null);
  const momentValue = React15.useMemo(() => {
    if (!value) return null;
    if (moment3.isMoment(value)) return value;
    if (typeof value === "string") return moment3(value);
    return null;
  }, [value]);
  const handleDateChange = (newValue) => {
    const dateString = newValue ? newValue.format("YYYY-MM-DD") : null;
    onChange(dateString);
  };
  useEffect(() => {
    if (momentValue && (minDate || maxDate)) {
      if (minDate && momentValue.isBefore(minDate, "day")) {
        setError(`Date must be after ${minDate.format("MM-DD-YYYY")}`);
        setWithinLimit == null ? void 0 : setWithinLimit(false);
      } else if (maxDate && momentValue.isAfter(maxDate, "day")) {
        setError(`Date must be before ${maxDate.format("MM-DD-YYYY")}`);
        setWithinLimit == null ? void 0 : setWithinLimit(false);
      } else {
        setError(null);
        setWithinLimit == null ? void 0 : setWithinLimit(true);
      }
    } else {
      setError(null);
      setWithinLimit == null ? void 0 : setWithinLimit(true);
    }
  }, [momentValue, minDate, maxDate, setWithinLimit]);
  return /* @__PURE__ */ React15.createElement(ErrorBoundary_default, { componentName: "DatePickerInput" }, /* @__PURE__ */ React15.createElement(ThemeProvider, null, /* @__PURE__ */ React15.createElement(Box, { width: "100%", marginBottom: 4 }, /* @__PURE__ */ React15.createElement(Box, { display: "flex", alignItems: "center", gap: 1.5 }, /* @__PURE__ */ React15.createElement(Typography, { fontSize: 14, color: "#000", fontWeight: 600 }, label)), /* @__PURE__ */ React15.createElement(Box, { mt: 1 }, /* @__PURE__ */ React15.createElement(
    DatePicker_default,
    {
      value: momentValue,
      onChange: handleDateChange,
      label,
      minDate,
      maxDate,
      disabled: limitLoading,
      rootButtonSx: {
        width: 180,
        height: 60,
        alignItems: "center",
        "& .MuiTypography-root": { fontSize: 14, fontWeight: 500 },
        "& .MuiSvgIcon-root": { fontSize: 20, width: 16, height: 16 }
      }
    }
  )), (error || helperText) && /* @__PURE__ */ React15.createElement(Box, { mt: 0.5 }, /* @__PURE__ */ React15.createElement(
    Typography,
    {
      fontSize: 12,
      color: error ? "error.main" : "text.secondary",
      sx: { wordWrap: "break-word" }
    },
    error || helperText
  )))));
};
var DatePickerInput_default = DatePickerInput;
var MappingButton = ({
  disabled,
  loading,
  onClick,
  variant,
  children,
  sx,
  icon
}) => {
  return /* @__PURE__ */ React15.createElement(
    Button,
    {
      disabled,
      variant,
      sx: __spreadValues({
        fontSize: "12px",
        height: "48px",
        minWidth: "180px",
        px: 4,
        lineHeight: "initial",
        bgcolor: variant === "text" || variant === "outlined" ? "#D7E8EC82" : "#122937",
        "&.Mui-disabled": {
          bgcolor: "#122937"
        }
      }, sx),
      startIcon: icon,
      onClick
    },
    loading ? /* @__PURE__ */ React15.createElement(CircularProgress, { size: 16, sx: { color: "white", mr: "8px" } }) : children
  );
};
var MappingButton_default = MappingButton;
var executeFieldCallbacks = (changedField, newValue, formState, inputFields, dynamicLimit) => {
  if (!changedField.callbacks || changedField.callbacks.length === 0) {
    const newState2 = __spreadValues({}, formState);
    set(newState2, changedField.statePath, newValue);
    return newState2;
  }
  const newState = __spreadValues({}, formState);
  const updatedFields = /* @__PURE__ */ new Set();
  set(newState, changedField.statePath, newValue);
  updatedFields.add(changedField.statePath);
  const executeCallbacksRecursive = (sourceField, sourceValue, currentStack) => {
    if (!sourceField.callbacks) return;
    sourceField.callbacks.forEach((callback) => {
      if (currentStack.includes(callback.target)) {
        console.warn(
          `Circular dependency detected: ${currentStack.join(" -> ")} -> ${callback.target}`
        );
        return;
      }
      if (updatedFields.has(callback.target)) {
        return;
      }
      try {
        const callbackResult = callback.callback(
          sourceValue,
          newState,
          dynamicLimit || void 0
        );
        set(newState, callback.target, callbackResult);
        updatedFields.add(callback.target);
        const targetField = inputFields.find(
          (field) => field.statePath === callback.target
        );
        if (targetField == null ? void 0 : targetField.callbacks) {
          executeCallbacksRecursive(targetField, callbackResult, [
            ...currentStack,
            callback.target
          ]);
        }
      } catch (error) {
        console.error(`Error executing callback for ${callback.target}:`, error);
      }
    });
  };
  executeCallbacksRecursive(changedField, newValue, [changedField.statePath]);
  return newState;
};
var collectInputFields = (activeStepData) => {
  var _a, _b, _c;
  const fields = [];
  if ((_a = activeStepData == null ? void 0 : activeStepData.config) == null ? void 0 : _a.inputs) {
    fields.push(...activeStepData.config.inputs);
  }
  if ((_b = activeStepData == null ? void 0 : activeStepData.config) == null ? void 0 : _b.tabs) {
    activeStepData.config.tabs.forEach((tab) => {
      if (tab.inputs) {
        fields.push(...tab.inputs);
      }
    });
  }
  if ((_c = activeStepData == null ? void 0 : activeStepData.config) == null ? void 0 : _c.inputGroups) {
    const collectFromGroups = (groups) => {
      const groupFields = [];
      groups.forEach((group) => {
        if (group.inputs) {
          groupFields.push(...group.inputs);
        }
        if (group.groups) {
          groupFields.push(...collectFromGroups(group.groups));
        }
      });
      return groupFields;
    };
    fields.push(...collectFromGroups(activeStepData.config.inputGroups));
  }
  return fields;
};
var initializeCallbackFields = (formState, inputFields, dynamicLimit) => {
  let newState = __spreadValues({}, formState);
  const processedFields = /* @__PURE__ */ new Set();
  const sortedFields = [...inputFields].sort((a, b) => {
    if (!a.callbacks && b.callbacks) return -1;
    if (a.callbacks && !b.callbacks) return 1;
    return 0;
  });
  sortedFields.forEach((field) => {
    if (field.callbacks && !processedFields.has(field.statePath)) {
      const currentValue = get(newState, field.statePath);
      if (currentValue !== void 0 && currentValue !== null) {
        newState = executeFieldCallbacks(
          field,
          currentValue,
          newState,
          inputFields,
          dynamicLimit
        );
        processedFields.add(field.statePath);
      }
    }
  });
  return newState;
};
var PercentageSlider = ({
  variant,
  label,
  value,
  min,
  max,
  helperText,
  onChange,
  limit,
  limitLoading,
  setWithinLimit
}) => {
  const [error, setError] = useState(null);
  const handleSliderChange = (_, newValue) => {
    onChange(newValue);
  };
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      onChange(null);
    } else {
      const newValue = parseFloat(inputValue);
      if (!isNaN(newValue) && newValue >= (min != null ? min : 0) && newValue <= (max != null ? max : 100)) {
        onChange(newValue);
      }
    }
  };
  useEffect(() => {
    if (((limit == null ? void 0 : limit.min) || (limit == null ? void 0 : limit.max)) && value !== null && value !== void 0) {
      if ((limit == null ? void 0 : limit.min) && value < (limit == null ? void 0 : limit.min)) {
        setError(`Minimum value is ${limit == null ? void 0 : limit.min}%`);
        setWithinLimit == null ? void 0 : setWithinLimit(false);
      } else if ((limit == null ? void 0 : limit.max) && value > (limit == null ? void 0 : limit.max)) {
        setError(`Maximum value is ${limit == null ? void 0 : limit.max}%`);
        setWithinLimit == null ? void 0 : setWithinLimit(false);
      } else {
        setError(null);
        setWithinLimit == null ? void 0 : setWithinLimit(true);
      }
    } else {
      setError(null);
      setWithinLimit == null ? void 0 : setWithinLimit(true);
    }
  }, [value, limit == null ? void 0 : limit.min, limit == null ? void 0 : limit.max]);
  return /* @__PURE__ */ React15.createElement(ErrorBoundary_default, { componentName: "PercentageSlider" }, /* @__PURE__ */ React15.createElement(ThemeProvider, null, /* @__PURE__ */ React15.createElement(Box, { width: "100%" }, /* @__PURE__ */ React15.createElement(Box, { display: "flex", alignItems: "center", gap: 1.5 }, /* @__PURE__ */ React15.createElement(Typography, { fontSize: 14, color: "#000", fontWeight: 600 }, label), limitLoading && /* @__PURE__ */ React15.createElement(CircularProgress, { size: 20 })), /* @__PURE__ */ React15.createElement(Box, { width: "100%", display: "flex", gap: 3 }, variant !== "small" && /* @__PURE__ */ React15.createElement(
    Slider,
    {
      disabled: limitLoading,
      value: value != null ? value : 0,
      onChange: handleSliderChange,
      valueLabelDisplay: "auto",
      min: min != null ? min : 0,
      max: max != null ? max : 100,
      step: 0.1,
      sx: {
        mt: "27px",
        ml: "10px"
      }
    }
  ), /* @__PURE__ */ React15.createElement(Box, { display: "flex", gap: 1, mt: variant === "small" && 2 }, /* @__PURE__ */ React15.createElement(
    TextField,
    {
      disabled: limitLoading,
      variant: "standard",
      type: "number",
      value: value != null ? value : "",
      onChange: handleInputChange,
      inputProps: {
        min: min != null ? min : 0,
        max: max != null ? max : 100,
        step: 0.1
      },
      sx: {
        "& .MuiInputBase-input": {
          fontSize: "24px",
          color: "#000",
          width: "65px",
          px: 0,
          textAlign: "center"
        }
      }
    }
  ), /* @__PURE__ */ React15.createElement(Box, { display: "flex", alignItems: "center", gap: 1 }, /* @__PURE__ */ React15.createElement(
    Typography,
    {
      fontSize: 24,
      color: "#000",
      lineHeight: "initial",
      sx: {
        whiteSpace: "nowrap"
      }
    },
    "%"
  ), helperText && /* @__PURE__ */ React15.createElement(
    Typography,
    {
      fontSize: 16,
      color: "#000",
      lineHeight: "initial",
      sx: {
        whiteSpace: "nowrap"
      }
    },
    helperText
  )))), /* @__PURE__ */ React15.createElement(Box, { height: "15px", mt: 1 }, error && /* @__PURE__ */ React15.createElement(Typography, { fontSize: 14, color: "#E52E2E", lineHeight: "initial" }, error)))));
};
var PercentageSlider_default = PercentageSlider;
var SingleSelectInput = ({
  label,
  value,
  options,
  helperText,
  onChange,
  limitLoading
}) => {
  return /* @__PURE__ */ React15.createElement(ErrorBoundary_default, { componentName: "SingleSelectInput" }, /* @__PURE__ */ React15.createElement(ThemeProvider, null, /* @__PURE__ */ React15.createElement(Box, { width: "100%" }, /* @__PURE__ */ React15.createElement(Box, { display: "flex", alignItems: "center", gap: 1.5 }, /* @__PURE__ */ React15.createElement(Typography, { fontSize: 14, color: "#000", fontWeight: 600 }, label), limitLoading && /* @__PURE__ */ React15.createElement(CircularProgress, { size: 20 })), /* @__PURE__ */ React15.createElement(Box, { mt: 2, height: "42px", display: "flex", alignItems: "flex-end" }, /* @__PURE__ */ React15.createElement(
    StyledTabs_default,
    {
      value,
      variant: "scrollable",
      scrollButtons: false,
      onChange: (_, value2) => onChange(value2)
    },
    options.map((option) => /* @__PURE__ */ React15.createElement(
      StyledTab_default,
      {
        key: option.value,
        value: option.value,
        label: option.label,
        disabled: limitLoading
      }
    ))
  ))), helperText && /* @__PURE__ */ React15.createElement(Box, null, /* @__PURE__ */ React15.createElement(Box, { height: "21px", width: "100%" }), /* @__PURE__ */ React15.createElement(Box, { mt: 2, height: "42px", display: "flex", alignItems: "center" }, /* @__PURE__ */ React15.createElement(Typography, { fontSize: 16, color: "#000", lineHeight: "initial" }, helperText)))));
};
var SingleSelectInput_default = SingleSelectInput;

// src/components/FormFlow/MultiInputFlexRenderer.tsx
var renderInput = (input, formState, handleInputChange, limit, dynamicLimitLoading, setWithinLimit, dynamicLimit, width) => {
  const currentValue = useMemo(() => {
    var _a, _b, _c;
    return get$1(
      formState,
      input.statePath,
      input.type === "select" ? (_c = (_b = (_a = input.options) == null ? void 0 : _a[0]) == null ? void 0 : _b.value) != null ? _c : null : 0
    );
  }, [input, formState]);
  const handleInputValueChange = (value) => {
    handleInputChange(value, input.statePath, input);
  };
  return /* @__PURE__ */ React15.createElement(
    Box,
    {
      key: input.statePath,
      width: input.type === "select" ? "auto" : "100%",
      display: "flex",
      gap: 3
    },
    input.type === "percentage" && /* @__PURE__ */ React15.createElement(
      PercentageSlider_default,
      {
        label: input.label,
        value: currentValue,
        onChange: handleInputValueChange,
        min: input.min,
        max: input.max,
        helperText: input.helperText,
        limit: limit == null ? void 0 : limit[input.statePath],
        limitLoading: dynamicLimitLoading,
        setWithinLimit
      }
    ),
    input.type === "currency" && /* @__PURE__ */ React15.createElement(
      CurrencyInput_default,
      {
        label: input.label,
        value: currentValue,
        helperText: input.helperText,
        onChange: handleInputValueChange,
        limit: limit == null ? void 0 : limit[input.statePath],
        limitLoading: dynamicLimitLoading,
        setWithinLimit
      }
    ),
    input.type === "select" && /* @__PURE__ */ React15.createElement(
      SingleSelectInput_default,
      {
        label: input.label,
        value: currentValue,
        options: input.options,
        onChange: handleInputValueChange,
        limitLoading: dynamicLimitLoading
      }
    ),
    input.type === "number" && /* @__PURE__ */ React15.createElement(
      CurrencyInput_default,
      {
        label: input.label,
        value: currentValue,
        helperText: input.helperText,
        onChange: handleInputValueChange,
        limit: limit == null ? void 0 : limit[input.statePath],
        limitLoading: dynamicLimitLoading,
        setWithinLimit
      }
    ),
    input.type === "slider" && /* @__PURE__ */ React15.createElement(
      PercentageSlider_default,
      {
        label: input.label,
        value: currentValue,
        onChange: handleInputValueChange,
        min: input.min,
        max: input.max,
        helperText: input.helperText,
        limit: limit == null ? void 0 : limit[input.statePath],
        limitLoading: dynamicLimitLoading,
        setWithinLimit
      }
    ),
    input.type === "date-picker" && /* @__PURE__ */ React15.createElement(
      DatePickerInput_default,
      {
        label: input.label,
        value: currentValue,
        onChange: handleInputValueChange,
        helperText: input.helperText,
        minDate: input.min ? moment3(input.min) : void 0,
        maxDate: input.max ? moment3(input.max) : void 0,
        limit: limit == null ? void 0 : limit[input.statePath],
        limitLoading: dynamicLimitLoading,
        setWithinLimit
      }
    )
  );
};
var MultiInputFlexRenderer = ({
  activeStepData,
  formState,
  dynamicLimit,
  dynamicLimitLoading,
  handleInputChange,
  setWithinLimit,
  flexConfig = { direction: "row", gap: 2 },
  inputGroups
}) => {
  const [limit, setLimit] = useState(null);
  const isColumnDirection = useMemo(() => {
    return flexConfig.direction === "column" || flexConfig.direction === "column-reverse";
  }, [flexConfig.direction]);
  const inputs = useMemo(() => {
    return get$1(activeStepData, "config.inputs", []);
  }, [activeStepData]);
  const getAllInputsFromGroup = (group) => {
    var _a;
    const inputs2 = group.inputs || [];
    const nestedInputs = ((_a = group.groups) == null ? void 0 : _a.flatMap(
      (nestedGroup) => getAllInputsFromGroup(nestedGroup)
    )) || [];
    return [...inputs2, ...nestedInputs];
  };
  useEffect(() => {
    var _a, _b, _c, _d;
    if (dynamicLimit) {
      const inputs2 = inputGroups ? inputGroups.flatMap((group) => getAllInputsFromGroup(group)) : get$1(activeStepData, "config.inputs", []);
      const firstInput = inputs2[0];
      if (firstInput) {
        const currentMinLimit = get$1(
          dynamicLimit,
          `min.${firstInput.type}`,
          null
        );
        const currentMaxLimit = get$1(
          dynamicLimit,
          `max.${firstInput.type}`,
          null
        );
        if (currentMinLimit || currentMaxLimit) {
          const effectedStatePath = (currentMinLimit == null ? void 0 : currentMinLimit.effectedStatePath) || (currentMaxLimit == null ? void 0 : currentMaxLimit.effectedStatePath);
          if (effectedStatePath) {
            const currentMinLimitValue = (_b = (_a = currentMinLimit == null ? void 0 : currentMinLimit.values) == null ? void 0 : _a[firstInput.type]) != null ? _b : null;
            const currentMaxLimitValue = (_d = (_c = currentMaxLimit == null ? void 0 : currentMaxLimit.values) == null ? void 0 : _c[firstInput.type]) != null ? _d : null;
            setLimit({
              [effectedStatePath]: {
                min: currentMinLimitValue,
                max: currentMaxLimitValue
              }
            });
          }
        }
      }
    } else {
      setLimit(null);
    }
  }, [dynamicLimit, inputGroups, activeStepData, formState]);
  if (inputGroups) {
    return /* @__PURE__ */ React15.createElement(
      Box,
      {
        display: "flex",
        flexDirection: flexConfig.direction || "row",
        gap: isColumnDirection ? 0 : flexConfig.gap || 2,
        flexWrap: flexConfig.wrap,
        justifyContent: flexConfig.justifyContent,
        alignItems: flexConfig.alignItems,
        width: flexConfig.width || "100%",
        height: flexConfig.height
      },
      inputGroups.map((group, index) => /* @__PURE__ */ React15.createElement(React15.Fragment, { key: index }, /* @__PURE__ */ React15.createElement(
        FlexInputGroupRenderer,
        {
          group,
          formState,
          dynamicLimit,
          dynamicLimitLoading,
          handleInputChange,
          setWithinLimit,
          limit
        }
      ), isColumnDirection && index < inputGroups.length - 1 && /* @__PURE__ */ React15.createElement(
        Box,
        {
          sx: {
            borderTop: "1px solid #E6E6E6",
            marginBottom: "24px"
          }
        }
      )))
    );
  }
  return /* @__PURE__ */ React15.createElement(
    Box,
    {
      display: "flex",
      flexDirection: flexConfig.direction || "row",
      gap: isColumnDirection ? 0 : flexConfig.gap || 2,
      flexWrap: flexConfig.wrap,
      justifyContent: flexConfig.justifyContent,
      alignItems: flexConfig.alignItems,
      width: flexConfig.width || "100%",
      height: flexConfig.height
    },
    inputs.map((input, index) => /* @__PURE__ */ React15.createElement(React15.Fragment, { key: input.statePath }, renderInput(
      input,
      formState,
      handleInputChange,
      limit,
      dynamicLimitLoading,
      setWithinLimit), isColumnDirection && index < inputs.length - 1 && /* @__PURE__ */ React15.createElement(
      Box,
      {
        sx: {
          borderTop: "1px solid #E6E6E6",
          marginBottom: "24px"
        }
      }
    )))
  );
};
var FlexInputGroupRenderer = ({
  group,
  formState,
  dynamicLimit,
  dynamicLimitLoading,
  handleInputChange,
  setWithinLimit,
  limit
}) => {
  const isColumnDirection = useMemo(() => {
    return group.flexConfig.direction === "column" || group.flexConfig.direction === "column-reverse";
  }, [group.flexConfig.direction]);
  const allElements = useMemo(() => {
    return [
      ...(group.inputs || []).map((input, index) => ({
        type: "input",
        data: input,
        key: `input-${index}`
      })),
      ...(group.groups || []).map((nestedGroup, index) => ({
        type: "group",
        data: nestedGroup,
        key: `group-${index}`
      }))
    ];
  }, [group.inputs, group.groups]);
  return /* @__PURE__ */ React15.createElement(Box, { width: group.flexConfig.width || "100%" }, group.label && /* @__PURE__ */ React15.createElement(
    Typography,
    {
      fontSize: 16,
      color: "#000",
      fontWeight: 700,
      textTransform: "uppercase"
    },
    group.label
  ), /* @__PURE__ */ React15.createElement(
    Box,
    {
      display: "flex",
      flexDirection: group.flexConfig.direction || "row",
      gap: isColumnDirection ? 0 : group.flexConfig.gap || 2,
      flexWrap: group.flexConfig.wrap,
      justifyContent: group.flexConfig.justifyContent,
      alignItems: group.flexConfig.alignItems,
      height: group.flexConfig.height
    },
    allElements.map((element, index) => /* @__PURE__ */ React15.createElement(React15.Fragment, { key: element.key }, element.type === "input" ? renderInput(
      element.data,
      formState,
      handleInputChange,
      limit,
      dynamicLimitLoading,
      setWithinLimit) : /* @__PURE__ */ React15.createElement(
      FlexInputGroupRenderer,
      {
        group: element.data,
        formState,
        dynamicLimit,
        dynamicLimitLoading,
        handleInputChange,
        setWithinLimit,
        limit
      }
    ), isColumnDirection && index < allElements.length - 1 && /* @__PURE__ */ React15.createElement(
      Box,
      {
        sx: {
          borderTop: "1px solid #E6E6E6",
          marginBottom: "24px"
        }
      }
    )))
  ));
};
var MultiInputFlexRenderer_default = MultiInputFlexRenderer;
var MultiInputComp = ({
  input,
  formState,
  dynamicLimit,
  dynamicLimitLoading,
  handleInputChange,
  setWithinLimit
}) => {
  const [limit, setLimit] = useState(null);
  const handleInputValueChange = (value) => {
    handleInputChange(value, input.statePath, input);
  };
  const currentValue = useMemo(() => {
    var _a, _b, _c;
    return get$1(
      formState,
      input.statePath,
      input.type === "select" ? (_c = (_b = (_a = input.options) == null ? void 0 : _a[0]) == null ? void 0 : _b.value) != null ? _c : null : 0
    );
  }, [input, formState]);
  useEffect(() => {
    var _a, _b;
    if (dynamicLimit) {
      const currentMinLimit = get$1(dynamicLimit, `min.${input.type}`, null);
      const currentMaxLimit = get$1(dynamicLimit, `max.${input.type}`, null);
      const currentMinLimitValue = (_a = currentMinLimit == null ? void 0 : currentMinLimit.values[input.type]) != null ? _a : null;
      const currentMaxLimitValue = (_b = currentMaxLimit == null ? void 0 : currentMaxLimit.values[input.type]) != null ? _b : null;
      setLimit({
        [currentMinLimit.effectedStatePath]: {
          min: currentMinLimitValue,
          max: currentMaxLimitValue
        }
      });
      if ((currentMinLimit == null ? void 0 : currentMinLimit.changedStatePath) || (currentMaxLimit == null ? void 0 : currentMaxLimit.changedStatePath)) {
        const changedMinInput = get$1(
          formState,
          currentMinLimit == null ? void 0 : currentMinLimit.changedStatePath,
          null
        );
        const changedMaxInput = get$1(
          formState,
          currentMaxLimit == null ? void 0 : currentMaxLimit.changedStatePath,
          null
        );
        const currentInputMinLimit = currentMinLimit == null ? void 0 : currentMinLimit.values[changedMinInput];
        const currentInputMaxLimit = currentMaxLimit == null ? void 0 : currentMaxLimit.values[changedMaxInput];
        setLimit({
          [currentMinLimit.effectedStatePath]: {
            min: currentInputMinLimit,
            max: currentInputMaxLimit
          }
        });
      }
    } else {
      setLimit(null);
    }
  }, [dynamicLimit, input == null ? void 0 : input.type, formState]);
  return /* @__PURE__ */ React15.createElement(Box, { key: input.statePath, width: "100%", display: "flex", gap: 3 }, input.type === "percentage" && /* @__PURE__ */ React15.createElement(
    PercentageSlider_default,
    {
      label: input.label,
      value: currentValue,
      onChange: handleInputValueChange,
      min: input.min,
      max: input.max,
      helperText: input.helperText,
      limit: limit == null ? void 0 : limit[input.statePath],
      limitLoading: dynamicLimitLoading,
      setWithinLimit
    }
  ), input.type === "percentage-small" && /* @__PURE__ */ React15.createElement(
    PercentageSlider_default,
    {
      variant: "small",
      label: input.label,
      value: currentValue,
      onChange: handleInputValueChange,
      min: input.min,
      max: input.max,
      helperText: input.helperText,
      limit: limit == null ? void 0 : limit[input.statePath],
      limitLoading: dynamicLimitLoading,
      setWithinLimit
    }
  ), input.type === "currency" && /* @__PURE__ */ React15.createElement(
    CurrencyInput_default,
    {
      label: input.label,
      value: currentValue,
      onChange: handleInputValueChange,
      helperText: input.helperText,
      limit: limit == null ? void 0 : limit[input.statePath],
      limitLoading: dynamicLimitLoading,
      setWithinLimit
    }
  ), input.type === "date-picker" && /* @__PURE__ */ React15.createElement(
    DatePickerInput_default,
    {
      label: input.label,
      value: currentValue,
      onChange: handleInputValueChange,
      helperText: input.helperText,
      minDate: input.min ? moment3(input.min) : void 0,
      maxDate: input.max ? moment3(input.max) : void 0,
      limit: limit == null ? void 0 : limit[input.statePath],
      limitLoading: dynamicLimitLoading,
      setWithinLimit
    }
  ));
};
var MultiInputComp_default = MultiInputComp;

// src/components/FormFlow/MultiInputRenderer.tsx
var MultiInputRenderer = ({
  activeStepData,
  formState,
  dynamicLimit,
  dynamicLimitLoading,
  handleInputChange,
  setWithinLimit
}) => {
  return /* @__PURE__ */ React15.createElement(Box, { display: "flex", gap: 3, width: "100%" }, get$1(activeStepData, "config.inputs", []).map((input) => {
    return /* @__PURE__ */ React15.createElement(
      MultiInputComp_default,
      {
        key: input.statePath,
        input,
        formState,
        dynamicLimit,
        dynamicLimitLoading,
        handleInputChange,
        setWithinLimit
      }
    );
  }));
};
var MultiInputRenderer_default = MultiInputRenderer;
var MultiTabRenderer = ({
  activeStepData,
  formState,
  dynamicLimit,
  dynamicLimitLoading,
  handleInputChange,
  setWithinLimit
}) => {
  const [limit, setLimit] = useState(null);
  const selectedTab = useMemo(() => {
    return get$1(activeStepData, "config.tabs", []).find(
      (tab) => tab.id === get$1(formState, activeStepData.statePath, "")
    );
  }, [activeStepData, formState]);
  useEffect(() => {
    var _a, _b;
    if (dynamicLimit) {
      const currentMinLimit = get$1(dynamicLimit, `min.${selectedTab.id}`, null);
      const currentMaxLimit = get$1(dynamicLimit, `max.${selectedTab.id}`, null);
      const currentMinLimitValue = (_a = currentMinLimit == null ? void 0 : currentMinLimit.values[selectedTab.id]) != null ? _a : null;
      const currentMaxLimitValue = (_b = currentMaxLimit == null ? void 0 : currentMaxLimit.values[selectedTab.id]) != null ? _b : null;
      setLimit({
        [currentMinLimit.effectedStatePath]: {
          min: currentMinLimitValue,
          max: currentMaxLimitValue
        }
      });
      if ((currentMinLimit == null ? void 0 : currentMinLimit.changedStatePath) || (currentMaxLimit == null ? void 0 : currentMaxLimit.changedStatePath)) {
        const changedMinInput = get$1(
          formState,
          currentMinLimit == null ? void 0 : currentMinLimit.changedStatePath,
          null
        );
        const changedMaxInput = get$1(
          formState,
          currentMaxLimit == null ? void 0 : currentMaxLimit.changedStatePath,
          null
        );
        const currentInputMinLimit = currentMinLimit == null ? void 0 : currentMinLimit.values[changedMinInput];
        const currentInputMaxLimit = currentMaxLimit == null ? void 0 : currentMaxLimit.values[changedMaxInput];
        setLimit({
          [currentMinLimit.effectedStatePath]: {
            min: currentInputMinLimit,
            max: currentInputMaxLimit
          }
        });
      }
    } else {
      setLimit(null);
    }
  }, [dynamicLimit, selectedTab, formState]);
  const inputWidth = useMemo(() => {
    var _a;
    return ((_a = selectedTab == null ? void 0 : selectedTab.inputs) == null ? void 0 : _a.length) ? `${100 / selectedTab.inputs.length}%` : "100%";
  }, [selectedTab]);
  return selectedTab == null ? void 0 : selectedTab.inputs.map((input) => {
    var _a, _b, _c;
    const currentValue = get$1(
      formState,
      input.statePath,
      input.type === "select" ? (_c = (_b = (_a = input.options) == null ? void 0 : _a[0]) == null ? void 0 : _b.value) != null ? _c : null : 0
    );
    const handleInputValueChange = (value) => {
      handleInputChange(value, input.statePath, input);
    };
    return /* @__PURE__ */ React15.createElement(Box, { key: input.statePath, width: inputWidth, display: "flex", gap: 3 }, input.type === "percentage" && /* @__PURE__ */ React15.createElement(
      PercentageSlider_default,
      {
        label: input.label,
        value: currentValue,
        onChange: handleInputValueChange,
        min: input.min,
        max: input.max,
        helperText: input.helperText,
        limit: limit == null ? void 0 : limit[input.statePath],
        limitLoading: dynamicLimitLoading,
        setWithinLimit
      }
    ), input.type === "currency" && /* @__PURE__ */ React15.createElement(
      CurrencyInput_default,
      {
        label: input.label,
        value: currentValue,
        helperText: input.helperText,
        onChange: handleInputValueChange,
        limit: limit == null ? void 0 : limit[input.statePath],
        limitLoading: dynamicLimitLoading,
        setWithinLimit
      }
    ), input.type === "select" && /* @__PURE__ */ React15.createElement(
      SingleSelectInput_default,
      {
        label: input.label,
        value: currentValue,
        options: input.options,
        onChange: handleInputValueChange,
        limitLoading: dynamicLimitLoading
      }
    ));
  });
};
var MultiTabRenderer_default = MultiTabRenderer;

// src/components/FormFlow/FormFlow.tsx
var renderFormattedText = (text) => {
  if (!text.includes("**")) return text;
  const parts = text.split("**");
  return /* @__PURE__ */ React15.createElement(React15.Fragment, null, parts.map(
    (part, index) => index % 2 === 0 ? /* @__PURE__ */ React15.createElement("span", { key: index }, part) : /* @__PURE__ */ React15.createElement("b", { key: index, style: { marginRight: "5px" } }, part)
  ));
};
var renderDescription = (description, dynamicLimit) => {
  if (!description) return null;
  if (typeof description === "string") {
    return /* @__PURE__ */ React15.createElement(Typography, { fontSize: 13, color: "#0008", mt: 1 }, description);
  }
  return /* @__PURE__ */ React15.createElement(Box, { mt: 1 }, description({ dynamicLimit }));
};
var FormFlow = ({
  activeStep,
  setActiveStep,
  formState,
  setFormState,
  steps,
  initialState
}) => {
  var _a;
  const [visible, setVisible] = useState(true);
  const [dynamicLimit, setDynamicLimit] = useState(
    null
  );
  const [dynamicLimitLoading, setDynamicLimitLoading] = useState(false);
  const [withinLimit, setWithinLimit] = useState(false);
  const activeStepData = useMemo(() => {
    return steps.find((step) => step.id === (activeStep == null ? void 0 : activeStep.currentStep));
  }, [activeStep, steps]);
  useEffect(() => {
    setVisible(true);
  }, [activeStep]);
  const handleStepChangeWithTransition = (nextStepFn) => {
    setVisible(false);
    setTimeout(() => {
      nextStepFn();
      setVisible(true);
    }, 300);
  };
  const handleSingleSelectClick = (nextStep, value, statePath, nextTimelineStep) => {
    handleStepChangeWithTransition(() => {
      setActiveStep((prev) => ({
        currentStep: nextStep,
        timelineStep: nextTimelineStep,
        prevActiveStep: prev
      }));
      setFormState((prev) => {
        const newState = __spreadValues({}, prev);
        set(newState, statePath, value);
        return newState;
      });
    });
  };
  const handleInputChange = (value, statePath, field) => {
    setFormState((prev) => {
      const allInputFields = collectInputFields(activeStepData);
      if (field == null ? void 0 : field.callbacks) {
        return executeFieldCallbacks(
          field,
          value,
          prev,
          allInputFields,
          dynamicLimit
        );
      } else {
        const newState = __spreadValues({}, prev);
        set(newState, statePath, value);
        return newState;
      }
    });
  };
  const handleNextStep = () => {
    handleStepChangeWithTransition(() => {
      setActiveStep((prev) => ({
        currentStep: activeStepData.nextStep,
        timelineStep: activeStepData == null ? void 0 : activeStepData.nextTimelineStep,
        prevActiveStep: prev
      }));
    });
  };
  const handleTabChange = (value, statePath, resetPaths) => {
    setFormState((prev) => {
      const newState = __spreadValues({}, prev);
      resetPaths.forEach((path) => {
        const initialValue = get(initialState, path, null);
        if (initialValue !== void 0) {
          set(newState, path, initialValue);
        }
      });
      set(newState, statePath, value);
      return newState;
    });
  };
  const getDynamicLimit = () => __async(null, null, function* () {
    setDynamicLimitLoading(true);
    const limit = yield activeStepData.dynamicLimit(formState);
    setDynamicLimit(limit);
    setDynamicLimitLoading(false);
  });
  useEffect(() => {
    if (activeStepData == null ? void 0 : activeStepData.dynamicLimit) {
      getDynamicLimit();
    } else {
      setDynamicLimit(null);
      setDynamicLimitLoading(false);
    }
  }, [(_a = activeStepData == null ? void 0 : activeStepData.dynamicLimit) == null ? void 0 : _a.toString()]);
  useEffect(() => {
    if (activeStepData) {
      const allInputFields = collectInputFields(activeStepData);
      const updatedState = initializeCallbackFields(
        formState,
        allInputFields,
        dynamicLimit
      );
      if (JSON.stringify(updatedState) !== JSON.stringify(formState)) {
        setFormState(updatedState);
      }
    }
  }, [dynamicLimit, activeStepData]);
  return /* @__PURE__ */ React15.createElement(ErrorBoundary_default, { componentName: "FormFlow" }, /* @__PURE__ */ React15.createElement(ThemeProvider, null, /* @__PURE__ */ React15.createElement(Box, { minHeight: 300 }, /* @__PURE__ */ React15.createElement(Fade, { in: visible, timeout: 300 }, /* @__PURE__ */ React15.createElement(Box, null, /* @__PURE__ */ React15.createElement(
    Typography,
    {
      variant: "h6",
      fontSize: 32,
      color: "#000",
      fontWeight: 600,
      lineHeight: "initial"
    },
    get(activeStepData, "title", "")
  ), renderDescription(activeStepData == null ? void 0 : activeStepData.description, dynamicLimit), /* @__PURE__ */ React15.createElement(Box, { mt: 3 }, get(activeStepData, "type", "") === "single-select" && /* @__PURE__ */ React15.createElement(
    List,
    {
      sx: {
        width: "100%",
        gap: 1,
        display: "flex",
        flexDirection: "column"
      }
    },
    get(activeStepData, "config.options", []).map(
      (option) => /* @__PURE__ */ React15.createElement(
        ListItemButton,
        {
          key: option.value,
          sx: {
            fontFamily: defaultTheme_default.typography.fontFamily,
            bgcolor: get(formState, activeStepData.statePath, "") === option.value ? "#196E8220" : "#F3F3F3",
            p: 3,
            borderRadius: 1,
            "&:hover": {
              bgcolor: "#196E8230"
            }
          },
          onClick: () => {
            var _a2, _b;
            return handleSingleSelectClick(
              (_a2 = option.nextStep) != null ? _a2 : activeStepData.nextStep,
              option.value,
              activeStepData.statePath,
              (_b = option.nextTimelineStep) != null ? _b : activeStepData.nextTimelineStep
            );
          }
        },
        renderFormattedText(option.label)
      )
    )
  ), get(activeStepData, "type", "") === "multi-input" && /* @__PURE__ */ React15.createElement(Box, { mt: 6 }, /* @__PURE__ */ React15.createElement(
    MultiInputRenderer_default,
    {
      activeStepData,
      formState,
      handleInputChange,
      dynamicLimit,
      dynamicLimitLoading,
      setWithinLimit
    }
  ), /* @__PURE__ */ React15.createElement(
    MappingButton_default,
    {
      disabled: get(activeStepData, "config.inputs", []).some(
        (input) => input.required === true && !get(formState, input.statePath, null)
      ) || get(activeStepData, "config.inputGroups", []).some(
        (group) => {
          var _a2;
          return (_a2 = group.inputs) == null ? void 0 : _a2.some((input) => {
            const value = get(formState, input.statePath, null);
            return input.required === true && (value === null || value === 0);
          });
        }
      ),
      onClick: handleNextStep,
      sx: {
        width: "fit-content",
        height: "60px",
        py: 0,
        mt: 3
      }
    },
    "NEXT"
  )), get(activeStepData, "type", "") === "multi-input-flex" && /* @__PURE__ */ React15.createElement(Box, { mt: 6 }, /* @__PURE__ */ React15.createElement(
    MultiInputFlexRenderer_default,
    {
      activeStepData,
      formState,
      handleInputChange,
      dynamicLimit,
      dynamicLimitLoading,
      setWithinLimit,
      flexConfig: get(activeStepData, "config.flexConfig"),
      inputGroups: get(activeStepData, "config.inputGroups")
    }
  ), /* @__PURE__ */ React15.createElement(
    MappingButton_default,
    {
      disabled: !withinLimit || get(activeStepData, "config.inputs", []).some(
        (input) => {
          const value = get(formState, input.statePath, null);
          return input.required === true && (value === null || value === 0);
        }
      ) || get(activeStepData, "config.inputGroups", []).some(
        (group) => {
          var _a2;
          return (_a2 = group.inputs) == null ? void 0 : _a2.some((input) => {
            const value = get(formState, input.statePath, null);
            return input.required === true && (value === null || value === 0);
          });
        }
      ),
      onClick: handleNextStep,
      sx: {
        width: "fit-content",
        height: "60px",
        py: 0,
        mt: 3
      }
    },
    "NEXT"
  )), get(activeStepData, "type", "") === "tabs" && /* @__PURE__ */ React15.createElement(Box, { mt: 4 }, /* @__PURE__ */ React15.createElement(
    StyledTabs_default,
    {
      value: get(formState, activeStepData.statePath, ""),
      variant: "scrollable",
      scrollButtons: false,
      onChange: (_, value) => handleTabChange(
        value,
        activeStepData.statePath,
        get(activeStepData, "config.tabs", []).map(
          (tab) => tab.inputs.map(
            (input) => input.statePath
          )
        ).flat()
      )
    },
    get(activeStepData, "config.tabs", []).map(
      (tab) => /* @__PURE__ */ React15.createElement(
        StyledTab_default,
        {
          key: tab.id,
          value: tab.id,
          label: tab.label
        }
      )
    )
  ), /* @__PURE__ */ React15.createElement(Box, { mt: 4, display: "flex", gap: 3, width: "100%" }, /* @__PURE__ */ React15.createElement(
    MultiTabRenderer_default,
    {
      activeStepData,
      formState,
      handleInputChange,
      dynamicLimit,
      dynamicLimitLoading,
      setWithinLimit
    }
  )), /* @__PURE__ */ React15.createElement(
    MappingButton_default,
    {
      disabled: !withinLimit || get(activeStepData, "config.tabs", []).some(
        (tab) => tab.inputs.some((input) => {
          const value = get(formState, input.statePath, null);
          return input.required === true && (value === null || value === 0);
        })
      ),
      onClick: handleNextStep,
      sx: {
        width: "fit-content",
        height: "60px",
        py: 0,
        mt: 3
      }
    },
    "NEXT"
  ))))))));
};
var FormFlow_default = FormFlow;

// src/components/FormFlow/types.ts
var FormStepType = /* @__PURE__ */ ((FormStepType2) => {
  FormStepType2["SINGLE_SELECT"] = "single-select";
  FormStepType2["MULTI_INPUT"] = "multi-input";
  FormStepType2["MULTI_INPUT_FLEX"] = "multi-input-flex";
  FormStepType2["TABS"] = "tabs";
  return FormStepType2;
})(FormStepType || {});

export { CalendarRangeComp_default, CurrencyInput_default, DatePickerInput_default, DatePicker_default, DateRangePicker_default, FormFlow_default, FormStepType, MappingButton_default, MultiInputFlexRenderer_default, PercentageSlider_default, QuickSelect_default, SingleSelectInput_default, collectInputFields, dateInRange, getLastMonthRange, weekDayLabels };
//# sourceMappingURL=chunk-DYLHTSF4.js.map
//# sourceMappingURL=chunk-DYLHTSF4.js.map